// extracted by mini-css-extract-plugin
export var cardTitle = "_j6-1";
export var commentBubble = "_j6-e";
export var commentForm = "_j6-a";
export var commentInput = "_j6-b";
export var commentLabel = "_j6-d";
export var commentPrompt = "_j6-9";
export var csatCard = "_j6-0";
export var feedbackSection = "_j6-7";
export var starDisabled = "_j6-6";
export var starEmpty = "_j6-5";
export var starFilled = "_j6-4";
export var starWrapper = "_j6-3";
export var starsContainer = "_j6-2";
export var submittedComment = "_j6-c";
export var thankYouText = "_j6-8";